<template>
  <el-dialog
    title="成果预览"
    :visible.sync="dialogVisible"
    width="1200px"
    top="5vh"
    class="achievement-preview-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="preview-container" v-loading="loading">
 


      <el-collapse  accordion >
  <el-collapse-item title="成果推荐意见" name="1">
    <div class="borderTop"></div>
    <div class="pd30" v-if="recommendationDetail">
      <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">高技术价值</div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
            <el-descriptions-item label="自主原创重大技术成果">{{formatValue(recommendationDetail.original)}}</el-descriptions-item>
            <el-descriptions-item label="前沿引领创新技术成果">{{formatValue(recommendationDetail.innovate)}}</el-descriptions-item>
            <el-descriptions-item label="产业关键核心技术成果">{{formatValue(recommendationDetail.core)}}</el-descriptions-item>
          </el-descriptions>
        </div>



        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">高产业价值</div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="助力传统产业转型升级">{{formatValue(recommendationDetail.tradition)}}</el-descriptions-item>
  <el-descriptions-item label="支撑战略新兴产业发展">{{formatValue(recommendationDetail.develop)}}</el-descriptions-item>
  <el-descriptions-item label="发挥未来产业定位方向">{{formatValue(recommendationDetail.strategy)}}</el-descriptions-item>
        </el-descriptions>
        </div>
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">高经济价值</div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="项目已实现营收规模大">{{formatValue(recommendationDetail.realize)}}</el-descriptions-item>
  <el-descriptions-item label="项目对地区经济贡献大">{{formatValue(recommendationDetail.market)}}</el-descriptions-item>
  <el-descriptions-item label="项目可实现效益预期大">{{formatValue(recommendationDetail.profit)}}</el-descriptions-item>
        </el-descriptions>
        </div>
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">高市场价值 </div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="成果目标市场规模巨大">{{formatValue(recommendationDetail.target_market)}}</el-descriptions-item>
  <el-descriptions-item label="成果推广应用场景多元">{{formatValue(recommendationDetail.promote)}}</el-descriptions-item>
  <el-descriptions-item label="成果市场生命周期可见">{{formatValue(recommendationDetail.life_cycle)}}</el-descriptions-item>
        </el-descriptions>
        </div>
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">高资本价值</div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="项目方向投资热度较高">{{formatValue(recommendationDetail.investment_heat)}}</el-descriptions-item>
  <el-descriptions-item label="项目团队运作能力较强">{{formatValue(recommendationDetail.team_operations)}}</el-descriptions-item>
  <el-descriptions-item label="项目实施风险防控可信">{{formatValue(recommendationDetail.implementation_risk)}}</el-descriptions-item>
        </el-descriptions>
        </div>
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">高转化价值</div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="主体企业创新能力到位">{{formatValue(recommendationDetail.generality)}}</el-descriptions-item>
  <el-descriptions-item label="成果转化资源要素到位">{{formatValue(recommendationDetail.resources)}}</el-descriptions-item>
  <el-descriptions-item label="成果转化落地进程到位">{{formatValue(recommendationDetail.prepare)}}</el-descriptions-item>
        </el-descriptions>
        </div>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">成果简要评语</div>
        </div>
        <div>
          <el-descriptions direction="vertical" :column="2" border>
            <el-descriptions-item label="成果简要评语" :span="2">{{recommendationDetail.comment}}</el-descriptions-item>
            <el-descriptions-item label="推荐时间">{{recommendationDetail.add_date}}</el-descriptions-item>
            <el-descriptions-item label="推荐单位/推荐个人">{{recommendationDetail.roc_org_str}}</el-descriptions-item>
          </el-descriptions>
        </div>
    </div>
    <div v-else class="pd30">感谢您的提交，您的成果已被选为入围成果</div>
  </el-collapse-item>
  <el-collapse-item title="预览申报成果信息登记表" name="2">
    <div class="borderTop"></div>
    <div class="pd30">
      <div class="reTitle mt20">科技成果转化双推双促工程</div>
    <div class="reTitle mt20">《申报成果信息登记表》</div>
    <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">申报单位信息</div>
        </div>
        <el-descriptions :column="2" border label-width="120px">
            <el-descriptions-item labelClassName="labelClass" label="申报单位名称" :span="2">{{achievementDetail?.org_name}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="单位所在省/市">{{achievementDetail?.org_province_name}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="单位成立时间">{{achievementDetail?.establish_date}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="单位产业属性">{{achievementDetail?.industrial_str}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="单位业务属性">{{achievementDetail?.business_str}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="单位从业人数（人）">{{achievementDetail?.org_person}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="单位负责人姓名">{{achievementDetail?.org_leader}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="成果申报人">{{achievementDetail?.declarant_name}}</el-descriptions-item>
            <el-descriptions-item labelClassName="labelClass" label="申报人联系方式">{{achievementDetail?.declarant_mobile}}</el-descriptions-item>
          </el-descriptions>

          <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">申报成果信息</div>
        </div>
        <el-descriptions :column="1" direction="vertical" border label-width="120px">
            <el-descriptions-item  label="申报成果名称" >{{achievementDetail?.name}}</el-descriptions-item>
            <el-descriptions-item  label="成果所属领域" >{{achievementDetail?.scope_str}}</el-descriptions-item>
            <el-descriptions-item  label="成果简介" >
              <div v-html="achievementDetail?.profile"></div>
            </el-descriptions-item>
   
          </el-descriptions>

                <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">技术创新亮点</div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="技术创新高度">{{achievementDetail?.height_str}}</el-descriptions-item>
  <el-descriptions-item label="技术创新属性">{{achievementDetail?.attribute_str}}</el-descriptions-item>
  <el-descriptions-item label="技术创新成果">{{achievementDetail?.achievement_str}}</el-descriptions-item>
        </el-descriptions>
        </div>

        
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">市场价值要点
          </div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="核心产品市场形态">{{achievementDetail?.shape_str}}</el-descriptions-item>
  <el-descriptions-item label="项目已实现市场规模">{{achievementDetail?.scale_str}}</el-descriptions-item>
  <el-descriptions-item label="项目未来市场预期">{{achievementDetail?.expect_str}}</el-descriptions-item>
        </el-descriptions>
        </div>


        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">转化要素难点

          </div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="转化所需资源难度">{{achievementDetail?.difficulty_str}}</el-descriptions-item>
  <el-descriptions-item label="转化资源到位程度">{{achievementDetail?.degree_str}}</el-descriptions-item>
  <el-descriptions-item label="转化项目投资力度">{{achievementDetail?.strength_str}}</el-descriptions-item>
        </el-descriptions>
        </div>




        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">转化已实现进程

          </div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="1" border>
  <el-descriptions-item label="TRL1-9">{{achievementDetail?.trl1_9_str}}</el-descriptions-item>
        </el-descriptions>
        </div>


        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">研发负责人

          </div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="姓名">{{achievementDetail?.leader_name}}</el-descriptions-item>
  <el-descriptions-item label="学历">{{achievementDetail?.leader_education_str}}</el-descriptions-item>
  <el-descriptions-item label="职称">{{achievementDetail?.leader_title_str}}</el-descriptions-item>
        </el-descriptions>
        </div>

        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">研发团队

          </div>
        </div>
        <div>
          <el-descriptions  direction="vertical" :column="3" border>
  <el-descriptions-item label="团队人数">{{achievementDetail?.team_person_str}}</el-descriptions-item>
  <el-descriptions-item label="中级以上人员占比">{{achievementDetail?.team_intermediate_str}}</el-descriptions-item>
  <el-descriptions-item label="团队合作经验">{{achievementDetail?.team_experience_str}}</el-descriptions-item>
        </el-descriptions>
        </div>
        
                      <div class="uploadFont">
                <div>1、企业相关证明</div>
                <div>（1）企业营业执照复印件;</div>
                <div>（2）企业资质/上年度财务数据证明；</div>
                <div>（3）企业海归人才回国工作证明材料；</div>
                <div>（4）专利获奖证书等奖项证明复印件;</div>
                <div>（5）技术成果推广应用证明材料（包括合同、用户使用效果证明）；</div>
                <div>2、项目介绍</div>
                <div>（1）项目PPT、WORD等相关简介</div>
                <div>（2）项目重大工程技术获奖证明复印件;</div>
                <div>（3）技术成果鉴定（评价）证明复印件；</div>
                <div>（4）国家或省部级重大技术工程项目证明材料;</div>
                <div>3、企业负责人证明材料</div>
                <div>（1）身份证复印件；</div>
                <div>（2）最高学历、学位证书、专业技术职务证书复印件；</div>
                <div>（3）本人主要参与的技术成果所获专利证明的复印件；</div>
                <div>（4）本人获奖或主要参与的工程技术项目等各类获奖证明（包括获奖人员名单排序）复印件;</div>
                <div>（5）发表的重要论文、论著首页（封面）复印件；</div>
                <div>（6）本人主要参与的技术成果所取得的经济、社会效益的有关证明。</div>


              </div>
        <div class="formHeader mt30">
          <div class="line"></div>
          <div class="formHeaderText">附件

          </div>
        </div>
        <div v-for="value in achievementDetail?.attachment" :key="value.id">
          <div class="file-item" @click="handleDownload(value)">
            <i class="el-icon-document"></i>
            <el-button type="text" >{{value.file_name}}</el-button>
          </div>
        </div>
    </div>

  </el-collapse-item>


</el-collapse>




  
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AchievementPreviewDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      achievementDetail: {},
      recommendationDetail:{},
      attachmentList: []
    }
  },
  methods: {
    open(id) {
      console.log("id========",id)
      this.dialogVisible = true
      this.loading = true
      
      // 等待所有接口完成后再关闭 loading
      this.getDate(id).finally(() => {
        this.loading = false
      })
    },
    getDate(id){
      return Promise.all([
        this.$API.getAchievementDetail({xid:id}).then(res => {
          console.log("getAchievementDetail 返回:", res)
          this.achievementDetail = res.data
        }), 
        this.$API.getRecommendationDetail({project_xid:id}).then(red => {
          console.log("getRecommendationDetail 返回:", red)
          this.recommendationDetail = red.data
        }).catch(err => {
          console.error("getRecommendationDetail 失败:", err)
        })
      ])
    },
    formatValue(value) {
      if (!value && value !== 0) {
        return '未选择'
      }
      if (value == 1) {
        return '符合'
      }
      if (value == 2) {
        return '一般'
      }
      return value
    },
    handleClose() {
      this.achievementDetail = {}
      this.attachmentList = []
    },
    getStateType(state) {
      const typeMap = {
        0: 'warning',  // 待推荐
        1: 'success',  // 已推荐
        2: 'danger'    // 已驳回
      }
      return typeMap[state] || 'info'
    },
    getStateText(state) {
      const textMap = {
        0: '待推荐',
        1: '已推荐',
        2: '已驳回'
      }
      return textMap[state] || '未知'
    },
    handleDetail() {
      this.dialogVisible = false
      // 打开详细弹框
      this.$refs.detailDialog.open(this.formData)
    },
    handleDownload(file) {
      if (!file.file_path) {
        this.$message.warning('文件路径不存在')
        return
      }
      window.open(file.file_path, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.file-item {
  i {
    margin-right: 10px;
    color: #409EFF;  /* 默认蓝色 */
    font-size: 18px;
  }
  

}
 ::v-deep .labelClass{
  width: 150px !important;
}
.mt20{
  margin-top: 20px;
}
.reTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: black;
  line-height: 30px;
  text-align: center;

}
.pd30{
  padding:10px 30px;
}
.borderTop{
  border-top: 1px solid #EBEEF5;
}
::v-deep .el-collapse-item__header{
  padding-left: 10px;
}
::v-deep .preview-container{
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
}
.achievement-preview-dialog {
  ::v-deep .el-dialog__body {
    padding: 0 20px 20px;
    max-height: 70vh;
    overflow-y: auto;
  }
}

.preview-container {
  padding: 0;
}

.preview-section {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e4e7ed;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.section-line {
  width: 3px;
  height: 16px;
  background: #2F86FF;
  margin-right: 10px;
}
.uploadFont {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 30px;
  margin-top: 20px;
}
.section-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 500;
  font-size: 16px;
  color: #231815;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.info-label {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #595959;
  white-space: nowrap;
  flex-shrink: 0;
}

.info-value {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #303133;
  word-break: break-all;
}

.profile-content {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #303133;
  line-height: 1.8;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;

  ::v-deep img {
    max-width: 100%;
    height: auto;
  }
}

.file-list {
  .file-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: #ecf5ff;

      i {
        color: #2F86FF;
      }
    }

    i {
      margin-right: 10px;
      color: #409EFF;
      font-size: 18px;
    }

    span {
      flex: 1;
      font-size: 14px;
      color: #303133;
    }
  }
}

.no-data {
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;

  i {
    font-size: 24px;
    margin-right: 8px;
  }
}
.mt30{
  margin-top: 30px;
}

.formHeaderText {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #231815;

}

.formHeader {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.line {
  width: 3px;
  height: 19px;
  background: #2F86FF;
  margin-right: 10px;
}
</style>
